module.exports = __webpack_public_path__ + "static/img/8areaA_04.80a9c2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/8areaA_04.png
// module id = 1060
// module chunks = 1